import styled from "styled-components";

const FlagRoundFrame = styled.div`
  overflow: hidden;
  width: 36px;
  height: 36px;
  border-radius: 100%;
  border: 1px solid ${({ theme }) => theme.colors.base3};
`;

export default FlagRoundFrame;
